import React, { useState } from "react";
import { SearchBar, Button, CreateTableNew as CreateTable } from "../../../../../common/APICommon";
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import ProcessorAccessAddEditModal from "../components/ProcessorAccessAddEditModal";

const ProcessorAccessTab = ({ user, data, searchData, saveProcessorAccess, showGeneralMessage }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const headers = ["ID", "Code", "Description", "Actions"];
  const accessors = ["id", "code", "description", "actions"];

  const actions = [
    {
      name: "Edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600 flex items-center",
      function: (item) => { setSelectedItem(item); setIsModalOpen(true); },
      visible: true
    }
  ];

  return (
    <>
      <div className="space-y-4">
        <div className="flex justify-between items-center">
          <SearchBar handleFilter={searchData} />
          <Button
            icon={<AddIcon />}
            name="New Code"
            className="bg-customGreen hover:bg-customGreenHover border-none"
            onClick={() => { setSelectedItem(null); setIsModalOpen(true); }}
          />
        </div>

        <CreateTable
          tableName="Process Manager Access List"
          headers={headers}
          accessors={accessors}
          data={data}
          actions={actions}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          itemsPerPage={10}
          totalItems={data?.length}
        />

      </div>

      <ProcessorAccessAddEditModal
        user={user}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        selectedItem={selectedItem}
        onSave={saveProcessorAccess}
        showGeneralMessage={showGeneralMessage}
      />
    </>
  );
};

export default ProcessorAccessTab;